export const LOCAL_STORAGE_KEYS = {
  COPILOT_CHAT_DATA: 'copilotChatData'
};

export const SESSION_STORAGE_KEYS = {
  PRE_LOGIN_ROUTE: 'pre_login_route'
};

export function storeToLocalStorage(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function getFromLocalStorage(key: string) {
  return localStorage.getItem(key);
}

export function removeFromLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export function saveCurrentRouteForLogin(currentRoute?: string) {
  try {
    const route = currentRoute || '';
    sessionStorage.setItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE, route);
  } catch (error) {
    console.error('Failed to save route to session storage:', error);
  }
}

export function clearPreLoginRoute() {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE);
  } catch (error) {
    console.error('Failed to clear route from session storage:', error);
  }
}

export function getPreLoginRoute(): string | null {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE);
  } catch (error) {
    console.error('Failed to retrieve preserved route:', error);
    return null;
  }
}
